import 'core-js/features/object/assign';
import lozad from 'lozad';

const lazyAssetsObserver = lozad();

export default lazyAssetsObserver;
